module.exports = __webpack_public_path__ + "f3745b8809e977d647712de3192b0068.png";


//////////////////
// WEBPACK FOOTER
// ./markup/img/dashboard.png
// module id = 1066
// module chunks = 0